import { ContextualMenu, IContextualMenuItem, Stack } from '@fluentui/react';
import React, { ReactNode, useState } from 'react';
import { nodeMapType } from '../../../utils';
import { setActivePoolDocument } from 'utility/cache/ui';

type RightClickMenuProps = {
  children: ReactNode;
  id: string;
  selectedPool: nodeMapType;
  onClick: (value: 'CREATE' | 'UPDATE' | 'DELETE') => void;
};

export const RightClickMenu: React.FC<RightClickMenuProps> = ({
  id,
  selectedPool,
  onClick,
  children,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);

  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    const { clientX, clientY } = event;

    const shouldOpen =
      !menuPosition ||
      menuPosition.x !== clientX ||
      menuPosition.y !== clientY ||
      !menuVisible;

    if (shouldOpen) {
      setActivePoolDocument(selectedPool);
      setMenuPosition({ x: clientX, y: clientY });
      setMenuVisible(true);
    }
  };

  const handleClick = () => {
    setMenuVisible(false);
  };

  const handleDismiss = () => {
    setMenuVisible(false);
    setMenuPosition(null);
  };

  const menuItems: IContextualMenuItem[] = [
    {
      key: 'add',
      text: 'Add Folder',
      iconProps: { iconName: 'FabricNewFolder' },
      disabled: !selectedPool._isUpdatable,
      onClick: () => onClick('CREATE'),
    },
    {
      key: 'edit',
      text: 'Update Folder',
      iconProps: { iconName: 'Edit' },
      disabled: !selectedPool._isUpdatable,
      onClick: () => onClick('UPDATE'),
    },
    {
      key: 'delete',
      text: 'Delete Folder',
      iconProps: { iconName: 'Delete' },
      disabled: !selectedPool._isDeletable,
      onClick: () => onClick('DELETE'),
    },
  ];

  return (
    <Stack
      onClick={handleClick}
      onContextMenu={handleContextMenu}
      style={{ cursor: 'pointer' }}
    >
      {menuVisible && menuPosition && (
        <ContextualMenu
          items={menuItems}
          hidden={!menuVisible}
          target={menuPosition}
          onItemClick={handleDismiss}
          onDismiss={handleDismiss}
        />
      )}
      {children}
    </Stack>
  );
};
